module.exports = __webpack_public_path__ + "static/media/Ellipsis-3.4s-167px.251a4e56.svg";